import {  memo  , useCallback , useState} from 'react';
import ListItem from '@mui/material/ListItem';
import {Box} from '@mui/material';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import { useTranslation } from "react-i18next";

const MapListItemBarrierFree = memo((props) => {
    const {dataList , selectData } = props;
    const [openDescriptionId , setOpenDescriptionId] = useState(null);
    const { t } = useTranslation();

    const nl2comma = useCallback((str) => {
        return str.replaceAll("¥/", "、");
    },[]);
    const nl2br = useCallback((str) => {
        return str.replaceAll("¥/", "<br />");
    },[]);

    const canDisplayDescription = useCallback((row) => {
        if(!row){
            return false;
        }
        return row.description !== '';
    },[]);

    const toggleOpenDescription  = (id) => {
        if(openDescriptionId === id){
            setOpenDescriptionId(null);
        }else{
            setOpenDescriptionId(id);
        }
    }

    return (
        dataList.map((row, index) => 
            <ListItem alignItems="flex-start" key={index}>
            <Card className={"flowerListItem"}>
                <Box sx={{display:'flex'}}>
                    <CardMedia
                        component="img"
                        sx={{ width: 140 }}
                        image={"/assets/images/descriptions/" + row.path}
                    />
                    <Box sx={{ display: 'block'}}>
                    <CardContent sx={{ flex: '1 0 auto' }}>
                        <Typography component="div" variant="h5" className="title">
                            {row.name}
                        </Typography>
                        <Typography variant="subtitle1" component="div" sx={{ color: 'text.secondary', overflowWrap: 'break-word' }}>
                            {nl2br(row.catchcopy)}
                        </Typography>
                    </CardContent>
                    </Box>
                </Box>
                {canDisplayDescription(row.description) && openDescriptionId === row.id?
                    <Box className='description' id={`description_${row.id}`}>
                        <div dangerouslySetInnerHTML={{__html: row.description}}></div>
                    </Box>:<></>
                    }
                <Box className='btnWrap'>
                    <Button variant="contained" onClick={() => selectData(row)} >
                        {t("common.btn_on_map")}
                    </Button>
                    {canDisplayDescription(row.description)?
                    <Button variant="outlined" onClick={() => toggleOpenDescription(row.id)} key={row.id}>
                        {openDescriptionId === row.id?<>{t("common.btn_close_detail")}</>:<>{t("common.btn_open_detail")}</>}
                    </Button>
                    :<></>
                    }
                </Box>
            </Card>
            </ListItem>
        )
    )
});
export default MapListItemBarrierFree